const actionTypes = {
  addConnectionByDelta: 'Add Connection by Delta',
  addConnectionByWallLine: 'Add Connection by Wall Line',
  addWall: 'Add Wall',
  addWall2Connections: 'Add Wall 2 Connections',
  changeGlassMeetingSign: 'Change Glass Meeting Sign',
  removeWall: 'remove-wall',
  downloads: 'Downloads',
  editWall: 'edit-wall',
  moveBuildingWallWithThickness: 'Move Building Wall With Thickness',
  reattachconnections: 'Re-Attach Connections',
  save: 'Save',
  switchInsideOutside: 'Switch Inside/Outside',
};

export default actionTypes;
